import * as React from 'react';
import { Table, CustomButton, ButtonType } from "soprasteria-ui-library";
import { IStandardPhrase } from '../../models/IStandardPhrase';
import { StandardPhraseApi } from '../../api/StandardPhraseApi';
import { useAuth } from '../../App';
import { IPage } from '../../models/IPage';
import '../../assets/styles/table.scss';

interface IStandardPhraseSelectionTable {
    standardPhraseRequestUrl: string;
    standardPhrases: IStandardPhrase[] | undefined;
    setSelectedStandardPhrase: React.Dispatch<React.SetStateAction<IStandardPhrase | undefined>>;
    setSelectedStandardPhraseText: React.Dispatch<React.SetStateAction<string | undefined>>;
    selectedStandardPhraseText?: string;
    setShowStandardPhraseTable: React.Dispatch<React.SetStateAction<boolean>>;
    standardPhraseTableHeaderExtraInfo?: string;
    getStandardPhrases: (page: IPage) => void;
    changeErrorMessage: (message: string) => void;
    changeSuccessMessage: (message: string) => void;
}

export const StandardPhraseSelectionTable: React.FunctionComponent<IStandardPhraseSelectionTable> = ({ standardPhraseRequestUrl, standardPhrases, setSelectedStandardPhrase, selectedStandardPhraseText, setSelectedStandardPhraseText, setShowStandardPhraseTable, standardPhraseTableHeaderExtraInfo, getStandardPhrases, changeErrorMessage, changeSuccessMessage }) => {
    const auth = useAuth();
    const api = new StandardPhraseApi(auth);

    const [isDeleting, setIsDeleting] = React.useState<boolean>(false);
    const [deletingId, setDeletingId] = React.useState<number>();

    const onRowClick = (standardPhraseText: string) => {
        setSelectedStandardPhraseText(`${selectedStandardPhraseText ?? ""} ${standardPhraseText}`);
    }

    const onEditStandardPhraseClick = (standardPhrase: IStandardPhrase) => {
        setSelectedStandardPhrase(standardPhrase);
        setShowStandardPhraseTable(false);
    }

    const deleteStandardPhrase = (id: number) => {
        const accepted = window.confirm("Är du säker på att du vill radera standardfrasen?");
        if (accepted) {
            setIsDeleting(true);
            setDeletingId(id);
            api.deleteStandardPhrase(standardPhraseRequestUrl, id, () => {
                setShowStandardPhraseTable(true);
                changeSuccessMessage("Standardfrasen har raderats");
                getStandardPhrases({ pageNumber: 1, pageSize: 10 });
            }, (error) => {
                changeErrorMessage(error);
            }, () => {
                setDeletingId(undefined);
                setIsDeleting(false)
            });
        }
    }

    return (
        <div className="scrollable-table">
            <Table hoverableRows>
                <thead>
                    <tr>
                        <th style={{ width: "65%" }}>Valbara standardfraser {standardPhraseTableHeaderExtraInfo ?? ""}</th>
                        <th style={{ width: "17%" }}>Redigera</th>
                        <th style={{ width: "18%" }} className="delete-btn">Radera</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        standardPhrases ?
                            standardPhrases.length > 0 ?
                                standardPhrases.map((standardPhrase, key) =>
                                    <tr key={key} className="clickable-row">
                                        <td className="table-data-link" style={{ width: "65%" }}><a onClick={() => onRowClick(standardPhrase.text)} title={standardPhrase.text}>{standardPhrase.text}</a></td>
                                        <td style={{ width: "17%" }} className="text-center"><CustomButton buttonType={ButtonType.edit} onClick={() => onEditStandardPhraseClick(standardPhrase)} buttonText="" /></td>
                                        <td style={{ width: "18%" }} className="delete-btn">
                                            <CustomButton
                                                buttonType={ButtonType.delete}
                                                onClick={() => deleteStandardPhrase(standardPhrase.standardPhraseId)}
                                                buttonText=""
                                                isLoading={isDeleting && deletingId === standardPhrase.standardPhraseId}
                                            />
                                        </td>
                                    </tr>
                                )
                                : <tr><td colSpan={1}>Det finns inga skapade standardfraser</td></tr>
                            : null
                    }
                </tbody>
            </Table>
        </div>
    )
}

